import { render } from "./SchemaBuilderComponent.vue?vue&type=template&id=077b8ca8"
import script from "./SchemaBuilderComponent.vue?vue&type=script&lang=js"
export * from "./SchemaBuilderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__